// extracted by mini-css-extract-plugin
module.exports = {"container":"PageError-PageError-container-f1605ca9"};